import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import styled from 'styled-components';
import { connect } from '../../Store';
import { LoaderWrapper, InfoBox as BaseInfoBox } from '../ReusableComponents';

const Wrapper = styled(BaseInfoBox)`
  padding: ${rem(20)} ${rem(20)} ${rem(10)} ${rem(20)};
  height: ${rem(100)};
  flex: 0 1 100%;
  ${({ theme }) => theme.media.m`
  margin-right: ${props => (props.last ? 0 : rem(20))};
  flex: 0 1 42%;
`};

  @media (min-width: 1200px) {
    margin-right: ${props => (props.last ? 0 : rem(20))};
    flex: 0 1 45%;
  }
`;

const Row = styled.div`
  display: flex;
  margin-bottom: ${rem(10)};
`;

const Label = styled.div`
  min-width: ${rem(150)};
  margin-right: ${rem(4)};
  text-overflow: ellipsis;
`;

const Value = styled.div`
  font-weight: bold;
  width: ${rem(130)};
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => (props.color ? props.color : '#000')};
`;

class InfoBox extends React.Component {
  render() {
    const { data, last, loading } = this.props;

    return (
      <Wrapper last={last}>
        {loading ? (
          <LoaderWrapper style={{ width: '100%' }}>
            <Loader size="xl" />
          </LoaderWrapper>
        ) : (
          data.map(item => {
            return (
              <Row>
                <Label>{item.label}</Label>
                <Value color={item.color ? item.color : '#000'}>
                  {item.value}
                </Value>
              </Row>
            );
          })
        )}
      </Wrapper>
    );
  }
}

InfoBox.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      color: PropTypes.string,
    }),
  ),
  last: PropTypes.bool,
  loading: PropTypes.bool,
};

InfoBox.defaultProps = {
  data: [],
  loading: false,
  last: false,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(InfoBox);



// WEBPACK FOOTER //
// ./src/Components/InfoBox/index.jsx